import { ehPlanoGratuito, estaEmPeriodoDeTeste } from '../../services/seguranca';
import logoAssistente from '../../assets/logo-assistente.png';
import logoLocaSmartCheck from '../../assets/logo-locasmartcheck.png';

export type ProdutoOferta = 'Assistente de WhatsApp' | 'App personalizado' | 'Site personalizado' | 'LocaSmartCheck';

export interface Oferta {
    produto: ProdutoOferta;
    titulo: string;
    texto: string;
    imagem?: string;
    icone?: 'smartphone' | 'site';
}

export const OFERTAS: Oferta[] = [
    {
        produto: 'Assistente de WhatsApp',
        titulo: 'Assistente de WhatsApp',
        imagem: logoAssistente,
        texto: 'O seu LocaSmartPro dentro do WhatsApp. Você pergunta por texto ou áudio sobre locações, faturas em atraso, veículos e locatários, e ele responde na hora com os dados da sua locadora. Também lança pagamentos, despesas e abre locações, sempre pedindo a sua confirmação antes de gravar.',
    },
    {
        produto: 'App personalizado',
        titulo: 'App personalizado',
        icone: 'smartphone',
        texto: 'O aplicativo do locatário publicado com a sua marca: nome, logo e cores da sua locadora nas lojas de aplicativos. O cliente acompanha vistorias, pagamentos, documentos e avisos de manutenção pelo celular, sem precisar ligar pra você.',
    },
    {
        produto: 'Site personalizado',
        titulo: 'Site personalizado',
        icone: 'site',
        texto: 'Um site profissional para a sua locadora, com domínio próprio e o visual da sua marca. A frota e os planos vêm direto do LocaSmartPro, e o interessado que preenche o formulário cai no seu WhatsApp pronto para fechar.',
    },
    {
        produto: 'LocaSmartCheck',
        titulo: 'LocaSmartCheck',
        imagem: logoLocaSmartCheck,
        texto: 'Vistoria digital integrada à locação. Fotos guiadas na entrega e na devolução, assinatura do locatário e laudo em PDF gerado na hora. Na devolução, a comparação lado a lado mostra as avarias e evita discussão na cobrança.',
    },
];

export const DATA_FIM_OFERTA = new Date('2026-11-30T23:59:59-03:00');
export const CHAVE_ULTIMA_ABERTURA = 'blackFriday2026UltimaAbertura';
export const NUMERO_WHATSAPP_CRM = '5585991491356';

export function linkWhatsAppOferta(produto: ProdutoOferta, nomeEmpresa: string): string {
    const mensagem = `Olá! Tenho interesse na oferta Black Friday do ${produto}. Empresa: ${nomeEmpresa}.`;
    return `https://wa.me/${NUMERO_WHATSAPP_CRM}?text=${encodeURIComponent(mensagem)}`;
}

const DIA_MS = 24 * 60 * 60 * 1000;
const FUSO_OFERTA_MINUTOS = -180;

function diaDaOferta(data: Date): number {
    return Math.floor((data.getTime() + FUSO_OFERTA_MINUTOS * 60 * 1000) / DIA_MS);
}

export function diasRestantes(agora: Date): number {
    return diaDaOferta(DATA_FIM_OFERTA) - diaDaOferta(agora);
}

export interface TempoRestante {
    dias: number;
    horas: number;
    minutos: number;
}

export function tempoRestante(agora: Date): TempoRestante {
    const restante = Math.max(0, DATA_FIM_OFERTA.getTime() - agora.getTime());
    const totalMinutos = Math.floor(restante / 60000);
    return {
        dias: Math.floor(totalMinutos / (24 * 60)),
        horas: Math.floor((totalMinutos % (24 * 60)) / 60),
        minutos: totalMinutos % 60,
    };
}

export function textoContador(t: TempoRestante): string {
    const mm = String(t.minutos).padStart(2, '0');
    if (t.dias > 1) return `Faltam ${t.dias} dias, ${t.horas}h ${mm}min`;
    if (t.dias === 1) return `Falta 1 dia, ${t.horas}h ${mm}min`;
    if (t.horas > 0) return `Faltam ${t.horas}h ${mm}min`;
    if (t.minutos > 0) return `Faltam ${t.minutos}min`;
    return 'Oferta encerrada';
}

export function ofertaAtiva(agora: Date): boolean {
    return agora.getTime() <= DATA_FIM_OFERTA.getTime();
}

export function elegivel(token: string): boolean {
    return !!token && !estaEmPeriodoDeTeste(token) && !ehPlanoGratuito(token);
}

export function hojeISO(agora: Date): string {
    const mes = String(agora.getMonth() + 1).padStart(2, '0');
    const dia = String(agora.getDate()).padStart(2, '0');
    return `${agora.getFullYear()}-${mes}-${dia}`;
}

type ArmazenamentoDiario = Pick<Storage, 'getItem' | 'setItem'>;

export function deveAbrirHoje(hoje: string, storage: ArmazenamentoDiario): boolean {
    return storage.getItem(CHAVE_ULTIMA_ABERTURA) !== hoje;
}

export function marcarAberturaHoje(hoje: string, storage: ArmazenamentoDiario): void {
    storage.setItem(CHAVE_ULTIMA_ABERTURA, hoje);
}

export function telefoneValido(mascarado: string): boolean {
    const digitos = (mascarado || '').replace(/\D/g, '');
    return digitos.length === 10 || digitos.length === 11;
}

export function existeModalAberto(doc: Document): boolean {
    return doc.querySelector('.modal.show, [data-modal-inicial]') !== null;
}

export function mensagemDoErro(err: any, padrao: string): string {
    const dados = err?.response?.data;
    return dados?.mensagem || dados?.Mensagem || padrao;
}
